import PropTypes from 'prop-types'
import { forwardRef } from 'react'
import styled from 'styled-components'

const StyledInput = styled.input`
  display: none;
`

// without this onChange doesn't trigger when file is opened 2nd time
const onClick = function (e) {
  e.target.value = ''
}

const FileInput = forwardRef(({ onChange, accept }, ref) => {
  return (
    <StyledInput
      type='file'
      ref={ref}
      onChange={onChange}
      onClick={onClick}
      accept={accept}
    />
  )
})

FileInput.displayName = 'FileInput'

FileInput.propTypes = {
  onChange: PropTypes.func,
  accept: PropTypes.string,
}

export default FileInput
